import { getYear, getMonth, getDate } from 'date-fns';
import Api from '../../../../../../shared/Api';
import {
    BookableDatesResult,
    BookingAddress,
    CustomerBookingResult,
    CustomerRebookingResult
} from "../types";


export class CustomerPhotographerBookingApi {
    static async getPhotographersForNewCustomerBooking(
        address: BookingAddress,
        selectedProductIds: string,
        brokerFirmId: number,
        bookingDate: Date
    ): Promise<CustomerBookingResult> {
        let { street, city, zip } = address;

        let parameters = {
            year: getYear(bookingDate),
            month: getMonth(bookingDate) + 1,
            day: getDate(bookingDate),
            bfid: brokerFirmId,
            p: selectedProductIds,
            street,
            city,
            zip
        };

        return new Api().get(`/views/photographer-booking/se360/customer/new-order`, parameters);
    }

    static async getPhotographersForCustomerRebooking(
        orderId: number,
        bookingDate: Date
    ): Promise<CustomerRebookingResult> {
        let parameters = {
            year: getYear(bookingDate),
            month: getMonth(bookingDate) + 1,
            day: getDate(bookingDate),
        };
        
        return new Api().get(`/views/photographer-booking/se360/customer/${orderId}`, parameters);
    }

    static async getFirstBookableDate(
        orderId: number | null,
        productIds: number[],
        brokerFirmId: number | null
    ): Promise<BookableDatesResult> {
        if (orderId !== null) {
            return new Api().get(`/views/photographer-booking/first-bookable-date/${orderId}`);
        }

        return new Api().get(`/views/photographer-booking/first-bookable-date`, {
            productIds,
            brokerFirmId
        });
    }
}
